<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
// Импортируем Mapbox GL
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { useWorkspaceStore } from '@stores/WorkspaceData';
import { mapService } from '@requests/Main/map.service';
const wpStore = useWorkspaceStore()

const mapInfo = ref({
  point: {
    Lat: null,
    Lng: null
  },
  map:{
    zoom: 2,
    max: 14,
    min: 0,
    step: null,
    zoom_scrol: null
  }
})
mapInfo.value.map.step = 100 / (mapInfo.value.map.max - mapInfo.value.map.min)
mapInfo.value.map.zoom_scrol = mapInfo.value.map.zoom * mapInfo.value.map.step
import Slider from 'primevue/slider';
const ZoomMap = (value) => {
  mapInstance.value.zoomTo(value/mapInfo.value.map.step, {
      duration: 50 // анимация 1 секунда
  });
}
import { tarService } from '@requests/Main/target.service';
// Наш сервер отдаёт тайлы до этого зума включительно, глубже — CyclOSM
const LOCAL_TILES_MAX_ZOOM = 8
// Инициализируем карту
function initMap() {
  const locateClient = window.location.origin;
  let src = ''
  if(locateClient == 'http://localhost:3000'){
    src = 'http://10.1.8.162'
  }
  else{
    src = locateClient
  }
  const map = new maplibregl.Map({
    container: 'map',
    style: {
        version: 8,
        sources: {
        'local-tiles': {
            type: 'raster',
            tiles: [`${src}/map/{z}/{x}/{y}.png`],
            tileSize: 256,
            minzoom: mapInfo.value.map.min,
            maxzoom: LOCAL_TILES_MAX_ZOOM
        },
        'osm-tiles': {
            type: 'raster',
            tiles: ['a', 'b', 'c'].map(s => `https://${s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png`),
            tileSize: 256,
            minzoom: LOCAL_TILES_MAX_ZOOM + 1,
            maxzoom: mapInfo.value.map.max
        }
        },
        layers: [{
        // Наши тайлы — подложка на любом зуме: глубже LOCAL_TILES_MAX_ZOOM растягиваются,
        // чтобы без интернета карта оставалась видна
        id: 'tiles-layer',
        type: 'raster',
        source: 'local-tiles',
        },{
        // Глубже наших тайлов — CyclOSM поверх
        id: 'osm-tiles-layer',
        type: 'raster',
        source: 'osm-tiles',
        minzoom: LOCAL_TILES_MAX_ZOOM + 1,
        }]
    },
    center: [0, 0], // starting position [lng, lat]
    zoom: mapInfo.value.map.zoom, // starting zoom
    minZoom: mapInfo.value.map.min, 
    maxZoom: mapInfo.value.map.max,
    dragRotate: false, // Отключает вращение карты
    pitchWithRotate: false, // Отключает изменение наклона вместе с вращением
    });

    map.on('style.load', () => {
      console.log(map)
        /*map.setProjection({
            type: 'globe', // Set projection to globe
        });*/
    });
    map.on('mousemove', (e) => {
      // Получаем координаты в градусах
      const { lng, lat } = e.lngLat
      const DECIMALS = 4
      mapInfo.value.point.Lat = Math.round(lat * 10 ** DECIMALS) / 10 ** DECIMALS
      mapInfo.value.point.Lng = Math.round(lng * 10 ** DECIMALS) / 10 ** DECIMALS
    });
    map.on('mouseleave', () => {
      mapInfo.value.point = {Lat: null,Lng: null }
    });
    map.on('zoom', () => {
      mapInfo.value.map.zoom_scrol = map.getZoom()* mapInfo.value.map.step
    });
    map.on('click', (e) => {
      if(ButtonBar.value.target){
        console.log(e,experiment.value)
        const DECIMALS = 4
        experiment.value.Tar.latitude = Math.round(e.lngLat.lat * 10 ** DECIMALS) / 10 ** DECIMALS
        experiment.value.Tar.longitude = Math.round(e.lngLat.lng * 10 ** DECIMALS) / 10 ** DECIMALS
        tarService.Put(experiment.value.Tar)
        DrawPoints()
      }
    });
    return map
}
const mapInstance = ref(null)
const experiment = ref(null)
const ButtonBar = ref({target: false})
let clickEvent = null
onMounted(() => {
  try {
    mapInstance.value = initMap()
    
    mapInstance.value.on('load', () => {
      console.log('Карта загружена!')
      setTimeout(async() => {
        experiment.value = await wpStore.experiment;
        DrawPoints()
      }, 500)
      
      // Здесь можно добавлять маркеры, слои и т.д.
      // mapInstance.value.addLayer(...)
    })
    
    mapInstance.value.on('error', (e) => {
      console.error('Ошибка Mapbox:', e.error)
    })
  } catch (error) {
    console.error('Ошибка инициализации карты:', error)
    const mapElement = document.getElementById('map')
    if (mapElement) {
      mapElement.innerHTML = `
        <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          color: #666;
          font-size: 18px;
          padding: 20px;
          text-align: center;
        ">
          ❌ Ошибка загрузки карты: ${error.message}
        </div>
      `
    }
  }
})
let markers = []
const DrawPoints = async () =>{
  
  
  if(mapInstance.value){
    DrawTrace()
    markers.forEach(marker => marker.remove());
    markers = []
    let points = [experiment.value.Tar]
    points.forEach(target => {
      const marker = new maplibregl.Marker()
      .setLngLat([target.longitude,target.latitude])
      .addTo(mapInstance.value);
      const label = document.createElement('span')
      label.className = 'map-label target-label'
      label.textContent = 'Цель'
      marker.getElement().appendChild(label)
      markers.push(marker)
    });
  }
}
const DrawTrace = async () => {
  const map = mapInstance.value
  if (!map) return

  const trace = await mapService.GetAllTrace()
  const data = buildTraceGeoJSON(trace || [])
  DrawTraceEnds(trace || [])

  const source = map.getSource('sat-trace')
  if (source) {
    source.setData(data)
    return
  }

  map.addSource('sat-trace', { type: 'geojson', data })
  map.addLayer({
    id: 'sat-trace-line',
    type: 'line',
    source: 'sat-trace',
    layout: {
      'line-join': 'round',
      'line-cap': 'round'
    },
    paint: {
      'line-color': ['get', 'color'],
      'line-width': 2
    }
  })
  // Стрелки направления полёта вдоль трассы
  if (!map.hasImage('trace-arrow')) map.addImage('trace-arrow', createArrowImage(), { sdf: true })
  map.addLayer({
    id: 'sat-trace-arrows',
    type: 'symbol',
    source: 'sat-trace',
    layout: {
      'symbol-placement': 'line',
      'symbol-spacing': 120,
      'icon-image': 'trace-arrow',
      'icon-size': 0.7,
      'icon-allow-overlap': true,
      'icon-ignore-placement': true
    },
    paint: {
      'icon-color': ['get', 'color']
    }
  })
}
// Стрелка «>» (смотрит по направлению линии) — рисуем на canvas, чтобы не зависеть от внешних ресурсов
const createArrowImage = () => {
  const size = 24
  const canvas = document.createElement('canvas')
  canvas.width = canvas.height = size
  const ctx = canvas.getContext('2d')
  ctx.strokeStyle = '#000'
  ctx.lineWidth = 4
  ctx.lineCap = 'round'
  ctx.lineJoin = 'round'
  ctx.beginPath()
  ctx.moveTo(8, 5)
  ctx.lineTo(17, 12)
  ctx.lineTo(8, 19)
  ctx.stroke()
  return ctx.getImageData(0, 0, size, size)
}
// Начало и конец трассы — HTML-маркеры (подписи в слоях карты требуют загрузки шрифтов из интернета)
let traceMarkers = []
const DrawTraceEnds = (trace) => {
  traceMarkers.forEach(marker => marker.remove())
  traceMarkers = []
  trace
    .filter(sat => sat?.coordinates?.length > 1)
    .forEach((sat, idx) => {
      const color = TRACE_COLORS[idx % TRACE_COLORS.length]
      const first = sat.coordinates[0]
      const last = sat.coordinates[sat.coordinates.length - 1]

      const start = document.createElement('div')
      start.className = 'trace-start'
      start.style.borderColor = color
      start.title = 'Начало трассы'

      const end = document.createElement('div')
      end.className = 'trace-end'
      end.style.background = color
      end.title = 'Конец трассы'

      traceMarkers.push(
        new maplibregl.Marker({ element: start }).setLngLat([first.longitude, first.latitude]).addTo(mapInstance.value),
        new maplibregl.Marker({ element: end }).setLngLat([last.longitude, last.latitude]).addTo(mapInstance.value),
      )
    })
}
// Разбивает трассу на отрезки при пересечении линии смены дат (±180°)
const splitTrackByAntimeridian = (coords) => {
  const lines = []
  let current = []

  for (let i = 0; i < coords.length; i++) {
    const lon = coords[i].longitude
    const lat = coords[i].latitude

    if (current.length) {
      const [prevLon, prevLat] = current[current.length - 1]
      const dLon = lon - prevLon

      if (Math.abs(dLon) > 180) {
        // Пересекли ±180 — считаем широту в точке пересечения
        const edge = prevLon > 0 ? 180 : -180
        const lonAdj = lon + (prevLon > 0 ? 360 : -360) // "развернутая" долгота
        const t = (edge - prevLon) / (lonAdj - prevLon)
        const latCross = prevLat + t * (lat - prevLat)

        current.push([edge, latCross])
        lines.push(current)
        current = [[-edge, latCross]]
      }
    }
    current.push([lon, lat])
  }
  if (current.length > 1) lines.push(current)
  return lines
}

const TRACE_COLORS = ['#ff3b30', '#ffcc00', '#34c759', '#00c7ff', '#af52de', '#ff9500']

const buildTraceGeoJSON = (trace) => ({
  type: 'FeatureCollection',
  features: trace
    .filter(sat => sat?.coordinates?.length > 1)
    .map((sat, idx) => ({
      type: 'Feature',
      properties: {
        id: idx,
        color: TRACE_COLORS[idx % TRACE_COLORS.length]
      },
      geometry: {
        type: 'MultiLineString',
        coordinates: splitTrackByAntimeridian(sat.coordinates)
      }
    }))
})
// Очистка при размонтировании компонента
onUnmounted(() => {
  if (mapInstance.value) {
    mapInstance.value.remove()
    mapInstance.value = null
  }
})
</script>

<template>
    <div id="map"></div>
    <div id="map-point">{{`${mapInfo.point.Lat} ш. ${mapInfo.point.Lng} д.`}}</div>
    <div id="map-right-tools">
      <Slider v-model="mapInfo.map.zoom_scrol" :step="mapInfo.map.step" class="w-56" @change="ZoomMap" orientation="vertical"/>
      
      <Button icon="pi pi-map-marker" @click="ButtonBar.target = !ButtonBar.target" size="small" severity="secondary" :variant="ButtonBar.target?'':'outlined'"/>
      <Button icon="pi pi-sync" @click="DrawPoints" size="small" severity="secondary" />
    </div>
</template>

<style>
#map {
  flex: 1;
  overflow: hidden;
  height: 100%;
}
#map .maplibregl-ctrl-bottom-right{
  display: none !important;
}
.trace-start{
  width: 10px;
  height: 10px;
  border: 3px solid;
  border-radius: 50%;
  background: #fff;
}
.trace-end{
  width: 14px;
  height: 14px;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.4);
}
.map-label{
  font-size: 12px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 4px;
  color: var(--p-form-field-color);
  background: var(--p-form-field-background);
  border: 1px solid var(--p-form-field-border-color);
  white-space: nowrap;
}
.target-label{
  position: absolute;
  left: 100%;
  top: 4px;
  margin-left: 2px;
  pointer-events: none;
}
#map-point {
  position: absolute;
  bottom: 0px;
  left: 0px;
  font-size: 1rem;
  color: var(--p-form-field-color);
  background: var(--p-form-field-disabled-background);
  border: 1px solid var(--p-form-field-border-color);
  border-radius: var(--p-form-field-border-radius);
  padding-block: 0.25rem;
  padding-inline: 0.25rem;
  margin: 5px;
}
#map-right-tools {
  padding: 5px;
  position: absolute;
  bottom: 0px;
  right: 0px;
  /*background: var(--p-form-field-disabled-background);
  border: 1px solid var(--p-form-field-border-color);
  border-radius: var(--p-form-field-border-radius);*/
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
</style>
